export enum FieldTypes {
  BASIC_FIELD = 'BASIC_FIELD',
  BASIC_OR_SELECT_FIELD = 'BASIC_OR_SELECT_FIELD',
  PLAIN_TEXT_FIELD = 'PLAIN_TEXT_FIELD',
  VALIDATED_TEXT_FIELD = 'VALIDATED_TEXT_FIELD',
  BOOLEAN = 'BOOLEAN',
  DATA_FIELDS = 'DATA_FIELDS',
  INVESTMENT_KNOWLEDGE_OPTIONS = 'INVESTMENT_KNOWLEDGE_OPTIONS',
  OPTIONAL_TRANSLATED_STRING = 'OPTIONAL_TRANSLATED_STRING',
  RISK_QUESTION_OPTIONS = 'RISK_QUESTION_OPTIONS',
  SELECT_FIELD = 'SELECT_FIELD',
  TEXT_FIELD = 'TEXT_FIELD',
  WORKFLOW_SELECT_FIELD = 'WORKFLOW_SELECT_FIELD',
  TRANSLATED_STRING = 'TRANSLATED_STRING',
  TABLE = 'TABLE',
  ARRAY = 'ARRAY',
  TIME_HORIZON_OPTIONS = 'TIME_HORIZON_OPTIONS',
  ATTACHMENT = 'ATTACHMENT',
  COUNTRY_SPECIFIC_TAX_ID = 'COUNTRY_SPECIFIC_TAX_ID',
  EXTENDED_BOOLEAN = 'EXTENDED_BOOLEAN',
  LIST_TILE = 'LIST_TILE',
  SELECT_CUSTOM_FIELDS = 'SELECT_CUSTOM_FIELDS',
  SCHEDULE_FREQUENCY_OPTIONS = 'SCHEDULE_FREQUENCY_OPTIONS',
  HTML_TEMPLATE = 'HTML_TEMPLATE',
  CHECKBOX = 'CHECKBOX',
  DEPOSIT_TYPE_SELECT_FIELD = 'DEPOSIT_TYPE_SELECT_FIELD',
  TRANSFER_TYPE_OPTIONS = 'TRANSFER_TYPE_OPTIONS',
  NUMBER_FIELD = 'NUMBER_FIELD',
  AUTOMATED_BANKING_SELECTED = 'AUTOMATED_BANKING_SELECTED',
  DIVIDER_WITH_TITLE = 'DIVIDER_WITH_TITLE',
  CREATE_MODEL_PORTFOLIO_OPTIONS = 'CREATE_MODEL_PORTFOLIO_OPTIONS',
  IMPLEMENTATION_WARNING = 'IMPLEMENTATION_WARNING',
  FORM_DEFINITION_SELECT_FIELD = 'FORM_DEFINITION_SELECT_FIELD',
  AUTOCOMPLETE_FIELD_ID_VERIFICATION = 'AUTOCOMPLETE_FIELD_ID_VERIFICATION',
  ROLE_SELECT_FIELD = 'ROLE_SELECT_FIELD',
  NET_WORTH_BUTTON = 'NET_WORTH_BUTTON',
  DRAGGABLE_FIELD = 'DRAGGABLE_FIELD',
  TITLE_FIELD = 'TITLE_FIELD',
  COMBINED_FIELDS = 'COMBINED_FIELDS',
  SCHEMA_SEARCH_FIELD = 'SCHEMA_SEARCH_FIELD',
  CONFIGURABLE_TABLE_PAGE_SELECT_FIELD = 'CONFIGURABLE_TABLE_PAGE_SELECT_FIELD',
  INTEGRATION_MULTI_SELECT = 'INTEGRATION_MULTI_SELECT',
}
